import sanitizeHtml from "sanitize-html";

export const getSanitizedHtmlFromAllTags = (html?: string | null) =>
  html ? sanitizeHtml(html, { allowedTags: [], allowedAttributes: {} }) : null;
